<template>
  <div class="input-group input-group-prepend-icon input-group-append-icon">
    <span class="input-group-prependable-icon mdi mdi-calendar"></span>
    <input ref="input" type="text" :placeholder="placeholder" class="form-control form-control-md">
    <a v-if="!!value.from" @click="clear" class="input-group-appendable-icon mdi mdi-close"></a>
  </div>
</template>

<script>
  import moment from 'moment'

  const format = 'DD.MM.YYYY'

  export default {
    props: ['value', 'placeholder'],
    methods: {
      formatValue(from, until) {
        return from.format(format) + ' - ' + until.format(format)
      },
      onChange(input, picker) {
        input.value = this.formatValue(picker.startDate, picker.endDate)
        this.$emit('input', {from: picker.startDate.format('YYYY-MM-DD'), until: picker.endDate.format('YYYY-MM-DD')})
      },
      clear() {
        this.$refs.input.value = ''
        this.$emit('input', {from: null, until: null})
      }
    },
    watch: {
      value(newValue) {
        if (!newValue.from && !newValue.until)
          this.$refs.input.value = ''
      }
    },
    mounted() {
      if (this.value.from && this.value.until)
        this.$refs.input.value = this.formatValue(moment(this.value.from), moment(this.value.until))

      $(this.$refs.input).daterangepicker({
        autoUpdateInput: false,
        cancelClass: 'btn-light',
        applyButtonClasses: 'btn-primary',
        locale: {format},
        alwaysShowCalendars: true,
        showCustomRangeLabel: false,
        ranges: {
          'Täna': [moment(), moment()],
          'Eile': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
          'Jooksev kuu': [moment().startOf('month'), moment().endOf('month')],
          'Eelmine kuu': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
        }
      }).on('apply.daterangepicker', (e, picker) => {
        this.onChange(e.target, picker)
      }).on('change', e => {
        const picker = $(e.target).data('daterangepicker')
        this.onChange(e.target, picker)
      })
    }
  }
</script>
